import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Homeinteriors from '../../components/homeinteriors/homeinteriors';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Logo.png'
import WhatsAppCTA from '../../components/whatsapp/whatappcta';
import Gallery from '../../components/gallery/gallery';


const GalleryPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'Portfolio'} />
            
            <Gallery />
            <Footer />
            <WhatsAppCTA />
            <Scrollbar />

        </Fragment>
    )
};

export default GalleryPage;